import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import type { ItemParticipationRequest } from '../../functions/src/itemParticipationPolicy.mjs';

export async function changeItemParticipation(scopeId: string, input: Omit<ItemParticipationRequest, 'tripId' | 'branchId'>) {
  const [tripId, nested, branchId, extra] = scopeId.split('/');
  if (!tripId || extra || nested !== undefined && (nested !== 'branches' || !branchId)) throw new Error('Reopen this trip and try again.');
  const call = httpsCallable<ItemParticipationRequest, { changed: boolean; joining: boolean }>(functions, 'changeItemParticipation');
  return (await call({ ...input, tripId, ...(branchId ? { branchId } : {}) })).data;
}
